import { useNavigate } from 'react-router-dom'
import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { useAuth } from '@/context'
import { useTranslation } from '@/hooks/useTranslation'

export function LoggedOutOverlay() {
	const { t } = useTranslation()
	const { showLogoutOverlay, logoutReason, dismissLogoutOverlay } = useAuth()
	const navigate = useNavigate()

	const handleContinue = () => {
		dismissLogoutOverlay()
		switch (logoutReason) {
			case 'account_not_verified':
				navigate('/verify-email', { replace: true })
				break
			case 'terms_not_accepted':
				// User must log in first; login flow will redirect to /accept-terms
				navigate('/login', { replace: true })
				break
			default:
				navigate('/login', { replace: true })
		}
	}

	const getMessage = () => {
		switch (logoutReason) {
			case 'session_invalidated':
				return t('components.loggedOutOverlay.sessionInvalidated')
			case 'token_reuse_detected':
				return t('components.loggedOutOverlay.tokenReuseDetected')
			case 'session_expired':
				return t('components.loggedOutOverlay.sessionExpired')
			case 'account_not_verified':
				return t('components.loggedOutOverlay.accountNotVerified')
			case 'terms_not_accepted':
				return t('components.loggedOutOverlay.termsNotAccepted')
			default:
				return t('components.loggedOutOverlay.generic')
		}
	}

	const getButtonText = () => {
		switch (logoutReason) {
			case 'account_not_verified':
				return t('components.loggedOutOverlay.goToVerifyEmail')
			case 'terms_not_accepted':
				// User must log in first; login flow redirects to accept-terms
				return t('components.loggedOutOverlay.goToLogin')
			default:
				return t('components.loggedOutOverlay.goToLogin')
		}
	}

	const getTitle = () => {
		switch (logoutReason) {
			case 'account_not_verified':
				return t('components.loggedOutOverlay.titleAccountNotVerified')
			case 'terms_not_accepted':
				return t('components.loggedOutOverlay.titleTermsNotAccepted')
			default:
				return t('components.loggedOutOverlay.title')
		}
	}

	return (
		<AlertDialog open={showLogoutOverlay}>
			<AlertDialogContent onEscapeKeyDown={(e: KeyboardEvent) => e.preventDefault()}>
				<AlertDialogHeader>
					<AlertDialogTitle>{getTitle()}</AlertDialogTitle>
					<AlertDialogDescription>{getMessage()}</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogAction onClick={handleContinue}>{getButtonText()}</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
